var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterfaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 8.5C9.25 9.94975 10.4253 11.125 11.875 11.125C13.3247 11.125 14.5 9.94975 14.5 8.5M4 16.2002V7.80017C4 6.82008 4 6.32967 4.19074 5.95532C4.35852 5.62604 4.62604 5.35852 4.95532 5.19074C5.32967 5 5.82008 5 6.80017 5H16.9502C17.9303 5 18.4196 5 18.794 5.19074C19.1233 5.35852 19.3917 5.62604 19.5594 5.95532C19.75 6.3293 19.75 6.81912 19.75 7.7973V16.2031C19.75 17.1813 19.75 17.6704 19.5594 18.0444C19.3917 18.3737 19.1233 18.6417 18.794 18.8094C18.42 19 17.9309 19 16.9527 19H6.7973C5.81912 19 5.3293 19 4.95532 18.8094C4.62604 18.6417 4.35852 18.3737 4.19074 18.0444C4 17.6701 4 17.1803 4 16.2002Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceIcon);
export default __webpack_public_path__ + "static/media/interface-icon.7dc28dfa3e590b21518d37e308894cbf.svg";
export { ForwardRef as ReactComponent };